class CopyToClipboard extends HTMLElement {
    constructor() {
        super();

        this.button = this.querySelector("[data-copy-button]");
        this.text = this.querySelector("[data-copy-text]");

        if (!this.button) return;

        this.originalText = this.text?.innerText || "Copy";

        this.button.addEventListener("click", async () => {
            try {
                const url = this.dataset.url || window.location.href;

                await navigator.clipboard.writeText(url);

                if (this.text) {
                    this.text.innerText = "Copied!";

                    clearTimeout(this.timeout);

                    this.timeout = setTimeout(() => {
                        this.text.innerText = this.originalText;
                    }, 2000);
                }
            } catch (error) {
                console.error("Copy failed:", error);
            }
        });
    }
}

if (!customElements.get("copy-to-clipboard")) {
    customElements.define("copy-to-clipboard", CopyToClipboard);
}